export const GET_SCORECARD_LIST = 'src/components/Riskfactor/List/action/Get_Scorecard_List';
export const getScoreCardList = () => {
    return {
        type: GET_SCORECARD_LIST
    }
}
export const GET_SCORECARD_LIST_SUCCESS = 'src/components/Riskfactor/List/action/Get_Scorecard_List_Success';
export const GET_SCORECARD_LIST_FAILURE = 'src/components/Riskfactor/List/action/Get_Scorecard_List_Failure';
export const getScoreCardListSuccess = (data) => {
    return {
        type: GET_SCORECARD_LIST_SUCCESS,
        data
    }
}
export const getScoreCardListFailure = (error) => {
    return {
        type: GET_SCORECARD_LIST_FAILURE,
        error
    }
}